import React from 'react';
import PropTypes from 'prop-types';

import RadioButtonInput from 'Components/FormInput/RadioButtonInput';

import styles from './RadioButtonGroup.scss';

const RadioButtonGroup = ({ name, selected, options, handleChange }) => (
  <div className="RadioButtonGroup">
    {options.map(option => {
      const { value, label } = option;
      return (
        <React.Fragment key={`option-${value}`}>
          <RadioButtonInput
            id={`${name}_${value}`}
            name={name}
            value={value}
            selected={selected === value}
            handleChange={el => handleChange(el.value)}
          />
          <label htmlFor={`${name}_${value}`}>{label}</label>
        </React.Fragment>
      );
    })}
  </div>
);

RadioButtonGroup.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired,
};

export default RadioButtonGroup;
